<template>
    <li class="list-item slider-item">
        <a class="item-link" v-bind:class="{'c-hover': !$parent.projectLoaded}" @click.prevent="loadProjectCondition" :href="this.$router.resolve({path: this.projectPath}).href">
            <img class="item-image" v-bind:class="{'c-hover': !$parent.projectLoaded}" :src="cover" :alt="project_data.title[$translate.lang]">
            <h2 class="item-title title--primary" v-bind:class="{'c-hover': !$parent.projectLoaded}">
                <span v-bind:class="{'c-hover': !$parent.projectLoaded}" v-for="(value) of project_data.title[$translate.lang]" v-bind:key="value.title">
                    <span v-for="(letter, index) in (value.split(''))" v-bind:class="{'l-inline': letter === ' ', 'c-hover': !$parent.projectLoaded}" v-bind:key="index">{{ letter }}</span>
                </span>
            </h2>
        </a>
    </li>
</template>

<script>
    
    import AssetsLoader from 'assets-loader'
    import assets from '../../data/assets.json'
            
    export default {

        props: ['project_id', 'project_data'],

        data() {
            return {
                cover: `/static/images/projects/${this.project_data.cover}`,
                projectAssets: assets.projects[this.project_id],
                projectLoading: false,
                app: this.$parent.$parent,
                projectPath: ''
            }
        },
        
        mounted() {
            this.projectPath = this.$parent.$parent.$refs.appbase.projectPath + '/' + this.project_id
            
        },
        updated() {
            this.projectPath = this.$parent.$parent.$refs.appbase.projectPath + '/' + this.project_id
        },
                
        methods: {
            
            loadProjectCondition: function() {
                if (this.app.isMobile) {
                    if (!this.$parent.projectLoaded && !this.$parent.initCanvasSlideshow && !this.projectLoading) {
                        this.projectAssets = assets.projects[this.project_id].mobile
                        this.loadProject()
                    }
                } else {
                    if (!this.$parent.projectLoaded && this.$parent.initCanvasSlideshow.checkIfPlaying() !== true && !this.projectLoading) {
                        this.projectAssets = assets.projects[this.project_id].desktop
                        this.loadProject()
                    }
                }
            },
            loadProject: function () {
                this.projectLoading = true

                if (!this.app.isMobile) {
                    this.$parent.initCanvasSlideshow.stopCanvas(this)
                }

                // permet d'éviter l'apparition des prev next en cas de load de projet en mode liste
                this.$parent.projectLoading = true
                this.$parent.sliderNavHidden = false
                
                // on met à jour le projet actif dans le compteur
                this.$parent.$refs.projectsCounter.setAttribute('data-counter', this.$attrs['data-id'] + 1);

                var self = this
                let loaderRef = this.app.$refs.appbase.$refs.loader

                loaderRef.isMaskDisabled = true
                loaderRef.isLoading = true
                loaderRef.percentLoaded = 0
                loaderRef.loaderVisible = true

                if (this.$parent.isList) {
                    // pour éviter bug en cas de changement de page en plein switch full/list
                    this.$parent.isAnimating = true

                    setTimeout(function () {
                        self.loadAssets(self, self.projectAssets, loaderRef)
                    }, 1300)
                } else {
                     setTimeout(function () {
                        self.loadAssets(self, self.projectAssets, loaderRef)
                    }, 600)
                }                    
            },
            
            loadAssets: function (self, assets, loaderRef) {                
                var loader = AssetsLoader({
                    assets: assets
                })
                .on('error', function(error) {
                    console.error(error);
                })
                .on('progress', function(progress) {
                    var percent = Math.round(progress*100)
                    loaderRef.loaderWidth < percent ? loaderRef.loaderWidth = percent : undefined
                    loaderRef.percentLoaded < percent ? loaderRef.percentLoaded = percent : undefined
                })
                .on('complete', function() {
                    setTimeout(function () {
                        self.goToProject()
                    }, 100)
                    setTimeout(function () {
                        loaderRef.loaderVisible = false
                    }, 600)
                })
                .start();
            },
            
            goToProject: function () {
                var self = this;
                
                setTimeout(function () {
                    self.$router.push({path: self.projectPath})
                    
                    self.projectLoading = false
                }, 600)
            }            
        }
        
    }

</script>


// WEBPACK FOOTER //
// src/components/ProjectListItem/ProjectListItem.vue